import MapEquipmentListDirective from './map-equipment-list.component';
import MapEquipmentDirective from './map-equipment.component';
import MapEquipmentController from './map-equipment.controller';
import equipmentListModule from '../equipment/equipment.module';
const mapEquipmentModule = angular.module('app.map.mapEquipment', [
  equipmentListModule,
  //THIRD PARTY
  'ui.router',
  'ui.bootstrap',
  'ui.router',
  'ncy-angular-breadcrumb',
  'gettext'
]);

mapEquipmentModule
  .controller('MapEquipmentController', MapEquipmentController)

  .directive('mapEquipmentList', MapEquipmentListDirective)
  .directive('mapEquipment', MapEquipmentDirective);

export default mapEquipmentModule.name;